export const initCarousel = (images) => {
    let currentImageIndex = 0;
    const imagesShown = 3;
    const totalImages = images.length;
    const showImages = () => {
        images.forEach((img, index) => {
            img.parentElement.style.display = (index >= currentImageIndex && index < currentImageIndex + imagesShown) ? 'block' : 'none';
        });
    };

    if(totalImages <= imagesShown) {
        showImages();
        return; 
    }

    const nextArrow = document.querySelector('.next-arrow');
    const prevArrow = document.querySelector('.prev-arrow');

    nextArrow.style.display = 'block';
    prevArrow.style.display = 'block';
    
    // Show next images
    nextArrow.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex + imagesShown) % totalImages;
        showImages();
    });

    // Show previous images
    prevArrow.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex - imagesShown + totalImages) % totalImages;
        showImages();
    });

    showImages();
};